module.exports = __webpack_public_path__ + "img/active_arrow_left.e1c88267.svg";